import { QueryClient } from '@tanstack/react-query';

import { ApiError } from '@/lib/api';

const PERMANENT_STATUS = new Set([401, 403, 404, 422]);

export function createTenantQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        retry: (failureCount, error) => {
          if (error instanceof ApiError && PERMANENT_STATUS.has(error.status)) return false;
          return failureCount < 1;
        },
        refetchOnWindowFocus: true,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
